import React from "react";
import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import { store } from "./store";
import "./index.css";
import { router } from "./routers/MainRouter";
import { RouterProvider } from "react-router-dom";
import "FMSLogger";
import { asyncWithLDProvider } from "launchdarkly-react-client-sdk";
import { initFaro, setTelemetryUserFromStorage } from "./utils/faroUtils";
import { AuthProvider } from "Components/Authentication/AuthProvider";
import { appTokenStore } from "Utils/authTokenStore";

const LAUNCHDARKLY_CLIENT_ID = window._env_.REACT_APP_LAUNCHDARKLY_CLIENT_ID;

if (initFaro()) {
  // Initialize the telemetry user context if the user is already logged in
  if (appTokenStore.read().idToken) {
    setTelemetryUserFromStorage();
  }
}

const App = () => (
  <Provider store={store}>
    <AuthProvider>
      <RouterProvider router={router} />
    </AuthProvider>
  </Provider>
);

(async () => {
  const root = ReactDOM.createRoot(
    document.getElementById("root") as HTMLElement
  );

  if (!LAUNCHDARKLY_CLIENT_ID) {
    console.warn(
      "LaunchDarkly client ID is not configured. Feature flags will be disabled."
    );
    root.render(<App />);
    return;
  }

  try {
    const LDProvider = await asyncWithLDProvider({
      clientSideID: LAUNCHDARKLY_CLIENT_ID,
    });

    root.render(
      <LDProvider>
        <App />
      </LDProvider>
    );
  } catch (error) {
    console.error("Failed to initialize LaunchDarkly:", error);
    root.render(<App />);
  }
})();
